import request from '@/http'
const api = 'wmsapp-service'
const apiff = 'ffsapp-service'
//获取粮情检测上部分数据
export function getData(params) {
	// params.appFlag='wms'
    return request({
        url: api+'/warehouse/equipment/bank/sensor/tree',
        method: 'post',
        data: params
    })
}
//获取企业+仓库+物料
export function getManyList(params) {
	// params.appFlag='wms'
    return request({
        url: api+'/warehouse/equipment/bank/supervise/granaryList',
        method: 'post',
        data: params
    })
}
// 查询被监管方名称
export function getSuperviseList(params) {
	// params.appFlag='wms'
    return request({
        url: apiff+'/farmingStatistics/selectApplyer',
        method: 'post',
        data: params
    })
}
